// @fileoverview : 경남-PMS > 고속성형기관리 > 설비수리요청
import { useModal } from "@/features/modal/ModalStackManager";
import { Calendar } from "@/features/ui/calendar";
import { GridTable } from "@/features/ui/PMS/gridTable";
import { Button, Flex, Input, Pagination, Select, Text } from "@mantine/core";
import { IconCalendar, IconSearch } from "@tabler/icons-react";
import { useState } from "react";
import { Column, SelectColumn } from "react-data-grid";

const FacilitiesMockupData = [
  {
    manufacturer: "태원정공",
    machineName: "STAND BENDING",
    errorType: "기계 오작동",
    machineType: "프레스",
    weldType: "CO2",
    manufactureDate: "2018-05-20",
    serialNumber: "HY-2022-001",
    manager: "김철수",
    machinePhoto: "machine1.jpg",
    specPlatePhoto: "spec1.jpg",
    capacityPlatePhoto: "cap1.jpg",
    manual: "manual1.pdf",
    overhaul: "2024-03-15",
    peripherals: "냉각장치",
    tonnage: "300T",
    voltage: "380V",
    factory: "경남공장",
    factoryDetail: "1라인",
    product: "차체 패널",
    priority: "상",
    requestDate: "2025-06-20",
    requestPhoto: "error1.jpg",
    requester: "홍길동",
    dueDate: "2025-06-30",
    completedDate: "2025-07-02",
    completedPhoto: "complete1.jpg",
    completedContent: "베어링 교체 및 재조정 대기",
    status: "대기",
  },
  {
    manufacturer: "현대중공업",
    machineName: "ROLLER CUTTER",
    errorType: "소음 발생",
    machineType: "절단기",
    weldType: "TIG",
    manufactureDate: "2017-11-10",
    serialNumber: "HY-2021-003",
    manager: "이영희",
    machinePhoto: "machine2.jpg",
    specPlatePhoto: "spec2.jpg",
    capacityPlatePhoto: "cap2.jpg",
    manual: "manual2.pdf",
    overhaul: "2023-09-01",
    peripherals: "진동방지대",
    tonnage: "120T",
    voltage: "220V",
    factory: "울산공장",
    factoryDetail: "3라인",
    product: "프레임 커버",
    priority: "중",
    requestDate: "2025-06-21",
    requestPhoto: "error2.jpg",
    requester: "박지성",
    dueDate: "2025-07-01",
    completedDate: "2025-07-02",
    completedPhoto: "complete1.jpg",
    completedContent: "베어링 교체 및 재조정 대기",
    status: "대기",
  },
  {
    manufacturer: "두산인프라",
    machineName: "PRESS 3000",
    errorType: "압력 저하",
    machineType: "프레스",
    weldType: "MIG",
    manufactureDate: "2020-01-12",
    serialNumber: "DS-2020-100",
    manager: "최민수",
    machinePhoto: "machine3.jpg",
    specPlatePhoto: "spec3.jpg",
    capacityPlatePhoto: "cap3.jpg",
    manual: "manual3.pdf",
    overhaul: "2024-06-01",
    peripherals: "센서",
    tonnage: "3000T",
    voltage: "440V",
    factory: "인천공장",
    factoryDetail: "A라인",
    product: "엔진 블록",
    priority: "상",
    requestDate: "2025-06-22",
    requestPhoto: "error3.jpg",
    requester: "강하늘",
    dueDate: "2025-07-05",
    completedDate: "2025-07-02",
    completedPhoto: "complete1.jpg",
    completedContent: "베어링 교체 및 재조정 대기",
    status: "대기",
  },
  {
    manufacturer: "삼성중공업",
    machineName: "AUTO WELDER",
    errorType: "이상 전류",
    machineType: "용접기",
    weldType: "ARC",
    manufactureDate: "2016-07-30",
    serialNumber: "SM-2016-333",
    manager: "이수연",
    machinePhoto: "machine4.jpg",
    specPlatePhoto: "spec4.jpg",
    capacityPlatePhoto: "cap4.jpg",
    manual: "manual4.pdf",
    overhaul: "2023-12-12",
    peripherals: "피더기",
    tonnage: "150T",
    voltage: "220V",
    factory: "거제공장",
    factoryDetail: "2라인",
    product: "배관 모듈",
    priority: "하",
    requestDate: "2025-06-23",
    requestPhoto: "error4.jpg",
    requester: "정현우",
    dueDate: "2025-06-30",
    completedDate: "2025-07-02",
    completedPhoto: "complete1.jpg",
    completedContent: "베어링 교체 및 재조정 대기",
    status: "대기",
  },
  {
    manufacturer: "기아자동차",
    machineName: "PANEL PRESS",
    errorType: "유압 누수",
    machineType: "프레스",
    weldType: "CO2",
    manufactureDate: "2019-08-15",
    serialNumber: "KIA-2019-777",
    manager: "조은별",
    machinePhoto: "machine5.jpg",
    specPlatePhoto: "spec5.jpg",
    capacityPlatePhoto: "cap5.jpg",
    manual: "manual5.pdf",
    overhaul: "2024-04-18",
    peripherals: "오일탱크",
    tonnage: "500T",
    voltage: "380V",
    factory: "화성공장",
    factoryDetail: "B라인",
    product: "차체 프레임",
    priority: "중",
    requestDate: "2025-06-24",
    requestPhoto: "error5.jpg",
    requester: "윤세진",
    dueDate: "2025-07-10",
    completedDate: "2025-07-02",
    completedPhoto: "complete1.jpg",
    completedContent: "베어링 교체 및 재조정 대기",
    status: "대기",
  },
  // ... 나머지 8개 더 간결하게 표기
  {
    manufacturer: "한화테크윈",
    machineName: "METAL FORMER",
    errorType: "센서 오류",
    machineType: "성형기",
    weldType: "레이저",
    manufactureDate: "2015-04-05",
    serialNumber: "HW-2015-111",
    manager: "오상훈",
    machinePhoto: "m6.jpg",
    specPlatePhoto: "s6.jpg",
    capacityPlatePhoto: "c6.jpg",
    manual: "m6.pdf",
    overhaul: "2024-01-01",
    peripherals: "자동로더",
    tonnage: "800T",
    voltage: "220V",
    factory: "대전공장",
    factoryDetail: "C1",
    product: "금속 프레임",
    priority: "상",
    requestDate: "2025-06-18",
    requestPhoto: "e6.jpg",
    requester: "김대현",
    dueDate: "2025-06-30",
    completedDate: "2025-07-02",
    completedPhoto: "complete1.jpg",
    completedContent: "베어링 교체 및 재조정 대기",
    status: "대기",
  },
  {
    manufacturer: "LS엠트론",
    machineName: "LASER CUT",
    errorType: "정지 불량",
    machineType: "절단기",
    weldType: "플라즈마",
    manufactureDate: "2022-03-11",
    serialNumber: "LS-2022-876",
    manager: "배지훈",
    machinePhoto: "m7.jpg",
    specPlatePhoto: "s7.jpg",
    capacityPlatePhoto: "c7.jpg",
    manual: "m7.pdf",
    overhaul: "2024-05-05",
    peripherals: "컨베이어",
    tonnage: "180T",
    voltage: "380V",
    factory: "청주공장",
    factoryDetail: "1호기",
    product: "절단 판재",
    priority: "하",
    requestDate: "2025-06-25",
    requestPhoto: "e7.jpg",
    requester: "서진아",
    dueDate: "2025-07-02",
    completedDate: "2025-07-02",
    completedPhoto: "complete1.jpg",
    completedContent: "베어링 교체 및 재조정 대기",
    status: "대기",
  },
  {
    manufacturer: "두산로보틱스",
    machineName: "WELD ROBOT",
    errorType: "동작 불능",
    machineType: "로봇",
    weldType: "TIG",
    manufactureDate: "2021-01-01",
    serialNumber: "DR-2021-222",
    manager: "장태수",
    machinePhoto: "m8.jpg",
    specPlatePhoto: "s8.jpg",
    capacityPlatePhoto: "c8.jpg",
    manual: "m8.pdf",
    overhaul: "2024-06-01",
    peripherals: "로봇암",
    tonnage: "50T",
    voltage: "220V",
    factory: "수원공장",
    factoryDetail: "D라인",
    product: "용접 부품",
    priority: "중",
    requestDate: "2025-06-26",
    requestPhoto: "e8.jpg",
    requester: "김예슬",
    dueDate: "2025-07-06",
    completedDate: "2025-07-02",
    completedPhoto: "complete1.jpg",
    completedContent: "베어링 교체 및 재조정 대기",
    status: "대기",
  },
  {
    manufacturer: "대우조선해양",
    machineName: "BIG PRESS",
    errorType: "전원 차단",
    machineType: "프레스",
    weldType: "CO2",
    manufactureDate: "2010-12-12",
    serialNumber: "DW-2010-456",
    manager: "임정우",
    machinePhoto: "m9.jpg",
    specPlatePhoto: "s9.jpg",
    capacityPlatePhoto: "c9.jpg",
    manual: "m9.pdf",
    overhaul: "2023-08-08",
    peripherals: "냉각기",
    tonnage: "1000T",
    voltage: "440V",
    factory: "옥포공장",
    factoryDetail: "대형1",
    product: "함체",
    priority: "상",
    requestDate: "2025-06-27",
    requestPhoto: "e9.jpg",
    requester: "김보라",
    dueDate: "2025-07-08",
    completedDate: "2025-07-02",
    completedPhoto: "complete1.jpg",
    completedContent: "베어링 교체 및 재조정 대기",
    status: "대기",
  },
  {
    manufacturer: "LG전자",
    machineName: "CNC CUTTER",
    errorType: "이상 진동",
    machineType: "절단기",
    weldType: "MIG",
    manufactureDate: "2018-09-30",
    serialNumber: "LG-2018-555",
    manager: "송재훈",
    machinePhoto: "m10.jpg",
    specPlatePhoto: "s10.jpg",
    capacityPlatePhoto: "c10.jpg",
    manual: "m10.pdf",
    overhaul: "2024-03-30",
    peripherals: "제어기",
    tonnage: "300T",
    voltage: "220V",
    factory: "구미공장",
    factoryDetail: "라인F",
    product: "내장 패널",
    priority: "중",
    requestDate: "2025-06-28",
    requestPhoto: "e10.jpg",
    requester: "오혜림",
    dueDate: "2025-07-09",
    completedDate: "2025-07-02",
    completedPhoto: "complete1.jpg",
    completedContent: "베어링 교체 및 재조정 대기",
    status: "대기",
  },
  {
    manufacturer: "포스코",
    machineName: "STEEL ROLL",
    errorType: "롤러 파손",
    machineType: "압연기",
    weldType: "플라즈마",
    manufactureDate: "2012-06-22",
    serialNumber: "POS-2012-909",
    manager: "한기훈",
    machinePhoto: "m11.jpg",
    specPlatePhoto: "s11.jpg",
    capacityPlatePhoto: "c11.jpg",
    manual: "m11.pdf",
    overhaul: "2023-05-20",
    peripherals: "센서",
    tonnage: "1200T",
    voltage: "440V",
    factory: "포항공장",
    factoryDetail: "압연1",
    product: "강판",
    priority: "상",
    requestDate: "2025-06-29",
    requestPhoto: "e11.jpg",
    requester: "양다빈",
    dueDate: "2025-07-12",
    completedDate: "2025-07-02",
    completedPhoto: "complete1.jpg",
    completedContent: "베어링 교체 및 재조정 대기",
    status: "대기",
  },
];

export const PressFacilitiesListPage = () => {
  const { openModal } = useModal();

  const columns: readonly Column<any>[] = [
    { key: "manufacturer", name: "기계 제조사", sortable: true, resizable: true },
    { key: "machineName", name: "기계 이름", sortable: true, resizable: true },
    { key: "machineType", name: "기계 종류", sortable: true, resizable: true },
    { key: "weldType", name: "용접 종류", sortable: true, resizable: true },
    { key: "manufactureDate", name: "제조 연원일", sortable: true, resizable: true },
    { key: "serialNumber", name: "제조 번호", sortable: true, resizable: true },
    { key: "manager", name: "담당자", sortable: true, resizable: true },
    { key: "machinePhoto", name: "기계 사진", sortable: true, resizable: true },
    { key: "specPlatePhoto", name: "스펙 명판 사진", sortable: true, resizable: true },
    { key: "capacityPlatePhoto", name: "능력 명판 사진", sortable: true, resizable: true },
    { key: "manual", name: "사용 설명서", sortable: true, resizable: true },
    { key: "overhaul", name: "오버홀", sortable: true, resizable: true },
    { key: "peripherals", name: "주변 장치", sortable: true, resizable: true },
    { key: "tonnage", name: "톤 수", sortable: true, resizable: true },
    { key: "voltage", name: "사용 전압", sortable: true, resizable: true },
    { key: "factory", name: "공장명", sortable: true, resizable: true },
    { key: "factoryDetail", name: "공장 세분화명", sortable: true, resizable: true },
    { key: "product", name: "생산 품목", sortable: true, resizable: true },
    { key: "priority", name: "우선순위", sortable: true, resizable: true },
    { key: "requestDate", name: "요청 날짜", sortable: true, resizable: true },
    { key: "requestPhoto", name: "요청 사진", sortable: true, resizable: true },
    {
      key: "errorType",
      name: "문제유형(필수)",
      sortable: true,
      resizable: true,
    },
    { key: "requester", name: "요청자", sortable: true, resizable: true },
    { key: "dueDate", name: "대기 요청 날짜", sortable: true, resizable: true },
    { key: "completedDate", name: "완료날짜(필수)", sortable: true, resizable: true },
    { key: "completedPhoto", name: "완료사진", sortable: true, resizable: true },
    { key: "completedContent", name: "완료내용(필수)", sortable: true, resizable: true },
    { key: "status", name: "상태변경", sortable: true, resizable: true },
  ];

  const [parentActivePage, setParentActivePage] = useState(1);

  const pageSize = 10; // 페이지당 행 수
  const totalParentRows = FacilitiesMockupData.length;
  const parentPaginatedRows = FacilitiesMockupData?.slice(
    (parentActivePage - 1) * pageSize,
    parentActivePage * pageSize,
  );

  return (
    <Flex gap="md" direction="column">
      <Flex justify={"space-between"}>
        <Text size="xl">설비 수리 요청 리스트</Text>
      </Flex>
      <Flex justify={"flex-end"} gap="sm">
        <Button
          leftIcon={<IconCalendar />}
          color="indigo"
          onClick={() => {
            openModal(<Calendar dates={[null, null]} type="range" />, null, "날짜 선택");
          }}
        >
          날짜선택
        </Button>
        <Select
          w={"8rem"}
          data={[
            { label: "기계 제조사", value: "manufacturer" },
            { label: "기계명", value: "machineName" },
            { label: "제조번호", value: "serialNumber" },
            { label: "담당자", value: "manager" },
            { label: "문제점", value: "errorType" },
          ]}
        />
        <Input w={"16rem"} placeholder="검색어를 입력하세요" rightSection={<IconSearch />} />
        <Button>검색</Button>
      </Flex>

      <GridTable
        headerList={[SelectColumn, ...columns]}
        row={parentPaginatedRows}
        setRow={() => {}} // 행 수정 핸들러는 필요에 따라 구현
      />
      <Pagination
        onChange={setParentActivePage} // 페이지 변경 핸들러
        value={parentActivePage}
        total={Math.ceil(totalParentRows / pageSize)} // 데이터에 따라 동적 계산
        size="lg"
        radius="sm"
        position="center"
      />
    </Flex>
  );
};
